import { render, staticRenderFns } from "./AlertTable.vue?vue&type=template&id=1f709c0c&scoped=true&"
import script from "./AlertTable.vue?vue&type=script&lang=js&"
export * from "./AlertTable.vue?vue&type=script&lang=js&"
import style0 from "./AlertTable.vue?vue&type=style&index=0&id=1f709c0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.6_fb85a9817f99bdf862e5e3a442a1fb91/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f709c0c",
  null
  
)

export default component.exports